import { Sizes, TextTypes } from '@sede-x/shell-ds-react-base';

import { EmptyStateSize } from '../EmptyState.types';

export const titleSize = (size: EmptyStateSize) => {
  switch (size) {
    case Sizes.ExtraSmall:
      return TextTypes.H5;
    case Sizes.Small:
      return TextTypes.H4;
    case Sizes.Large:
      return TextTypes.H2;
    default:
      return TextTypes.H3;
  }
};

export const descriptionSize = (size: EmptyStateSize) => {
  if (size === Sizes.ExtraSmall) {
    return Sizes.Small;
  }

  return size;
};

export const getVisualPlaceholderType = (image: boolean, pictogram: boolean, icon: boolean) => {
  if (image) {
    return 'image';
  }
  if (pictogram) {
    return 'pictogram';
  }
  if (icon) {
    return 'icon';
  }

  return 'none';
};
